import React from "react"
import Modal from "aldoo-ra/Modal"
import ColorPicker from "../../components/ColorPicker.jsx"

const ColorPropertyEditor = ({
  isOpen,
  onClose,
  onColorSelect,
  currentColor = "",
  title = "Select Color"
}) => {
  if (!isOpen) return null

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      variant="admin"
      className="w-auto h-auto"
      closeOnEscape
    >
      <ColorPicker
        onColorSelect={onColorSelect}
        onClose={onClose}
        initialColor={currentColor}
      />
    </Modal>
  )
}

export default ColorPropertyEditor